import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", ";\n\n  &:last-of-type {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 ", ";\n\n  & + & {\n    margin-top: auto;\n    padding-top: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  border-left-width: 0;\n  border-right-width: 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: ", " 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  width: ", "; /* for nicer ripple effect */\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  margin: -", " 0 -", " -", "; /* for nicer ripple effect */\n  padding: ", " 0 ", " ", "; /* for nicer ripple effect */\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  &:empty {\n    display: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  margin: ", "; /* for nicer ripple effect */\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  border-top: ", ";\n  padding: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: space-between;\n  overflow-y: auto;\n  width: 100%;\n\n  /* apply theme colors to typography elements that can be inside navbar */\n  ", ",\n  ", ",\n  ", ",\n  ", ",\n  ", ",\n  ", " {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { rgba } from 'polished';
import { Heading1, Heading2, Heading3, Heading4, Paragraph, Subtext } from '@scp/ui-shared/components/typography';
import { color } from '@scp/ui-shared/theme/variables';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { APP_BAR_COLOR_BY_THEME, APP_BAR_TEXT_COLOR_BY_THEME } from './baseTypes';
export var DIVIDER_BORDER = "1px solid ".concat(rgba(color.palette.white, 0.1));
export var DIVIDER_BORDER_LIGHT = "1px solid ".concat(color.border);
export var barBase = css(_templateObject(), function (props) {
  return APP_BAR_COLOR_BY_THEME[props.colorTheme];
}, Heading1, Heading2, Heading3, Heading4, Subtext, Paragraph, function (props) {
  return APP_BAR_TEXT_COLOR_BY_THEME[props.colorTheme];
});
export var sectionBase = css(_templateObject2(), DIVIDER_BORDER, function (props) {
  return props.showTopBorder ? DIVIDER_BORDER : '0';
}, function (props) {
  return props.noSpacing ? "".concat(baselineToRem(2)) : "".concat(baselineToRem(2), " ").concat(baselineToRem(4));
});
export var logoRowBase = css(_templateObject3(), function (props) {
  return props.fullWidthLogo ? "".concat(baselineToRem(8), " 0 ").concat(baselineToRem(4), " ").concat(baselineToRem(4)) : "".concat(baselineToRem(8), " ").concat(baselineToRem(4), " ").concat(baselineToRem(4));
});
export var contentAfterLogoBase = css(_templateObject4());
export var linkStylesBase = css(_templateObject5(), baselineToRem(2), baselineToRem(2), baselineToRem(4), baselineToRem(2), baselineToRem(2), baselineToRem(4));
export var logoLinkBase = css(_templateObject6(), linkStylesBase, function (props) {
  return props.fullWidthLogo ? "100%" : "calc(100% + ".concat(baselineToRem(4), ")");
});
export var navigationBase = css(_templateObject7(), function (props) {
  return props.lightBackground ? DIVIDER_BORDER_LIGHT : DIVIDER_BORDER;
}, baselineToRem(2));
export var menuWrapperBase = css(_templateObject8(), baselineToRem(2), baselineToRem(2));
export var appLinkWrapperBase = css(_templateObject9(), baselineToRem(4), baselineToRem(16));